export const GET_ORDER_DETAIL_LIST_REQUEST = "get_order_detail_list_request";
export const GET_ORDER_DETAIL_LIST_RESPONSE = "get_order_detail_list_response";

export const GET_ORDER_DETAIL_WITH_LINES_BY_ORDER_ID_REQUEST =
  "get_order_detail_with_lines_by_order_id_request";
export const GET_ORDER_DETAIL_WITH_LINES_BY_ORDER_ID_RESPONSE =
  "get_order_detail_with_lines_by_order_id_response";

export const SET_ORDER_STATUS_REQUEST = "set_order_status_request";
export const SET_ORDER_STATUS_RESPONSE = "set_order_status_response";
